import React from "react"
import ReactDOM from "react-dom"
import ParkingProductPricingTableContainer from "./parking-product-pricing-table-container-component.jsx"

export default class ParkingProductPricingTableModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ParkingProductPricingTableContainer {...self.modelJson} />, self.elem)
  }
}
